/**
 * The AdditionalOrderItemConfiguration is an object with additional info about VVS and personal use
 * it is set for every ticket (order-item * quantity)
 *
 */
import {Model} from './Model';
import {Order} from './Order';
import {Product} from './Product';
import {OrderItem} from './OrderItem';
import {PublicTransportConfig} from './PublicTransportConfig';
import {Slot} from './Slot';
import {store} from '../store';

export class AdditionalOrderItemConfiguration extends Model {
  public orderItemId: string | number = 0;
  public parentOrderItemId: string | number | null = null;
  public personalUse: boolean | null = null;
  public publicTransportConfig: PublicTransportConfig | null = null;
  public productId: number | null = null;
  public slotId: number | null = null;
  public orderItem: OrderItem | null = null;

  constructor(data: any) {
    super(data);
    this.orderItemId = data.orderItemId;
    this.parentOrderItemId = data.parentOrderItemId;
    this.publicTransportConfig = data.publicTransportConfig;
    this.personalUse = data.personalUse;
    this.productId = data.productId;
    this.slotId = data.slotId;
  }

  getOrderItem(order: Order | null): OrderItem | null {
    let foundOrderItem: OrderItem | null = null;
    if (order) {
      order.orderItems.forEach((orderItem) => {
        if (orderItem.id === this.orderItemId) {
          foundOrderItem = orderItem;
        }

        if (foundOrderItem === null) {
          foundOrderItem = orderItem.subOrderItems.find((soi) => soi.id === this.orderItemId) || null;
        }
      });
    }
    return foundOrderItem;
  }

  getProduct(): Product | null {
    let storeInstance: any = store;
    let _order: Order = storeInstance.getters.getCurrentOrder;
    let _products: Product[] = storeInstance.getters.getProducts;
    if (_order && _products) {
      const orderItem = this.getOrderItem(_order);
      return _products.find(p => p.id === orderItem?.productId) ?? null;
    }
    return null;
  }

  toString(): string {
    return ``;
  }
}
